import { type MaybeRef, get } from '@vueuse/core'
import { SurveyResponseTypeRow } from '@openesg/supabase/models'

export type Props = MaybeRef<
  | Pick<
      SurveyResponseTypeRow,
      'score_e' | 'score_s' | 'score_g' | 'grade' | 'score'
    >
  | undefined
>

export function useScores(surveyResponse: Props) {
  const score = computed(() => get(surveyResponse)?.score?.toFixed(0) || '0')
  const grade = computed(() => get(surveyResponse)?.grade || 'E')
  const gradeClass = computed(() => {
    return 'grade-' + grade.value
  })

  return {
    score,
    grade,
    gradeClass,
  }
}
